export default {
  1: "ofertaCA",
  2: "oferta",
  3: "cliente",
  4: "confirmar",
  5: "clienteCA"
};
